import * as React from 'react';

import * as styles from './styles.css';

interface IPopupProps {
  clickOutside?(): void;
  children?: React.ReactNode;
}

export const Popup = (props: IPopupProps) => {
  return (
    <div className={styles['popup-wrapper']}>
      <div className={styles['popup-background']} onClick={props.clickOutside} />

      <div className={styles['popup']}>{props.children}</div>
    </div>
  );
};
